import { useFormContext } from "../context/FormContext/index.js";
import { RenderConditionsType } from "../types.js";
export const useShouldRenderElement = element => {
  const {
    watch
  } = useFormContext();
  const {
    conditions,
    type
  } = element?.renderConditions ?? {
    conditions: [],
    type: RenderConditionsType.ONE_OF
  };
  if (conditions.length === 0) {
    return true;
  }
  const values = watch(conditions.map(({
    field
  }) => field));
  const typeFn = (type ?? RenderConditionsType.ONE_OF) === RenderConditionsType.ONE_OF ? 'some' : 'every';
  return conditions[typeFn](condition => {
    return condition.values.some(val => values.includes(val));
  });
};